import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IRiskListItem, RiskListItem } from "./riskListItem";

export interface IRiskListItems extends ListItems<IRiskListItem> {
}

export class RiskListItems extends ListItems<RiskListItem> implements IRiskListItems {
    constructor();
    constructor(obj: IRiskListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RiskListItem);
    }
}